import React, { useMemo } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { workdeskTicketsSelector } from 'store/selectors/workdesk-tickets.selector';
import styled from 'styled-components/macro';
import loadingImg from 'assets/images/spinner.gif';
import { manualSiActions } from 'store/actions/manual-si.actions';

interface MatUiCheckboxProps {
  name?: string;
  label?: string;
  defaultValue?: boolean;
  size?: any; // mat-ui props
  disabled?: boolean;
  handleChange?: Function;
  value?: boolean;
  ticketId: string;
}

/**
 * For the main page
 * @param param0
 */
const SiCheckbox: React.FC<MatUiCheckboxProps> = ({
  name,
  ticketId,
  size,
  disabled,
  handleChange: handleChangeFromProps,
  value: siStatus = false,
}) => {
  const isManualSiLoadingSelector = useMemo(
    () =>
      createSelector(workdeskTicketsSelector, (wdTickets) => {
        return ticketId
          ? wdTickets.isPostingManualSiIdMap[ticketId] || false
          : false;
      }),
    [ticketId],
  );

  const isManualSiLoading = useSelector(isManualSiLoadingSelector);

  const appearDisable = useMemo(() => disabled || isManualSiLoading, [
    disabled,
    isManualSiLoading,
  ]);

  const dispatch = useDispatch();

  const handleToggleSi = () => {
    dispatch(manualSiActions.postManualSi(ticketId, !siStatus));
  };

  return (
    <SFormControlLabel
      control={
        isManualSiLoading ? (
          <SSpinnerImg src={loadingImg} />
        ) : (
          <Checkbox
            checked={siStatus}
            name={name}
            color="primary"
            size={size}
            onClick={() => handleToggleSi()}
          />
        )
      }
      className={isManualSiLoading ? 'is-loading' : ''}
      label="SI"
      disabled={appearDisable}
    />
  );

  // return (
  //   <>
  //     <FormControlLabel
  //       control={
  //         <Checkbox
  //           checked={siStatus}
  //           name={name}
  //           color="primary"
  //           size={size}
  //           onClick={() => handleClickSi()}
  //         />
  //       }
  //       label="SI"
  //       disabled={disabled}
  //     />
  //     <FormControlLabel
  //       control={
  //         <Checkbox
  //           checked={siStatus}
  //           name={name}
  //           color="primary"
  //           size={size}
  //           onClick={() => handleClickNonSi()}
  //         />
  //       }
  //       label="Non SI"
  //       disabled={disabled}
  //     />
  //   </>
  // );
};

export default SiCheckbox;

const SSpinnerImg = styled.img`
  width: 1.8rem;
  margin-right: 0.3rem;
`;
const SFormControlLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root.is-loading {
    margin-left: -2px;
  }
  &.MuiFormControlLabel-root {
    height: 2rem;
    margin-right: 0;
  }
`;
